export enum GenderName {
  MALE = 'men',
  FEMALE = 'women',
}

export const getCurrentPageGenderContext = (_pathname: string, search: string) => {
  let gender: GenderName | undefined = undefined
  if (_pathname.search(/\bmen\b/) >= 0 || search.search(/\bmen\b/) >= 0) {
    gender = GenderName.MALE
  } else if (_pathname.search(/\bwomen\b/) >= 0 || search.search(/\bwomen\b/) >= 0) {
    gender = GenderName.FEMALE
  }
  return gender
}
